
import { fecthBasicList } from '@/api/material/basic';

export default {
  props: {
    fnChange: {
      type: Function,
      default: function _default() {}
    },
    id: {
      type: [String, Number],
      default: ''
    }
  },
  data: function data() {
    return {
      loading: true,
      options: [],
      base_package: ''
    };
  },

  watch: {
    id: function id(val) {
      if (val) {
        this.base_package = Number(val);
      }
    }
  },
  methods: {
    remoteBase: function remoteBase(query) {
      var _this = this;

      if (query !== '') {
        this.loading = true;
        fecthBasicList({
          page: 1,
          search_field: 'id_or_app_name',
          keyword: query
        }).then(function (res) {
          _this.loading = false;
          _this.options = res.data.data.list;
        }).catch(function () {
          _this.options = [];
          _this.loading = false;
        });
      } else {
        this.options = [];
      }
    },
    handleChange: function handleChange() {
      this.fnChange(this.base_package);
    }
  },
  mounted: function mounted() {
    this.remoteBase(' ');
  }
};